import orderBy from "lodash/orderBy";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import * as Table from "reactabular-table";
import { Flex, Text } from "rebass";
import { bindActionCreators, compose } from "redux";
import * as sort from "sortabular";
import { PvCaret, PvCheck, PvLinkGreen } from "styles/CustomComponents";
import { resolve } from "table-resolver";
import { selectLessonAction } from "../../ducks/lessonsEdit";
import { LessonTypeIcon } from "../../util/IconUtil";


// TODO: maybe convert to styled(...) and move to components
const EllipsisText = ({ text, width = "inherit" }) => (
  <Text
    title={text}
    style={{
      width,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
  >
    {text}
  </Text>
);

class LessonsEditDataTable extends React.Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};

    const sortable = sort.sort({
      getSortingColumns,
      onSort: (selectedColumn) => {
        this.setState({
          sortingColumns: sort.byColumn({
            sortingColumns: this.state.sortingColumns,
            selectedColumn,
          }),
        });
      },
      strategy: sort.strategies.byProperty,
    });

    const columns = [
      {
        property: "orderNumber",
        header: {
          label: "#",
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        visible: true,
      },
      {
        property: "lessonType",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="datatable.lesson_type" />
              <PvCaret />
            </Flex>
          ),
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        props: {
            style: {
            textAlign: "center",
          },
        },
        cell: {
          formatters: [(value) => <LessonTypeIcon type={value} />],
        },
        visible: true,
      },
      {
        property: "description",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="datatable.lesson_description" />
              <PvCaret />
            </Flex>
          ),
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        props: {
          style: {
            width: "15em",
          },
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <Text>
                  <PvLinkGreen
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.selectLesson(props.rowData.entityId);
                    }}
                  >
                    <EllipsisText text={value} width="15em"></EllipsisText>
                  </PvLinkGreen>
                </Text>
              );
            },
          ],
        },
        visible: true,
      },
      {
        property: "examClasses",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="datatable.exam_class" />
              <PvCaret />
            </Flex>
          ),
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        props: {
          style: {
            width: "15em",
          },
        },
        cell: {
          formatters: [
            (examClasses) => {
              const formatted = (examClasses || [])
                .map((ec) => ec.name || ec)
                .join(", ");
              return <EllipsisText text={formatted} />;
            },
          ],
        },
        visible: true,
      },
      {
        property: "requiredForIndependentTraining",
        header: {
          label: <Translate value="datatable.independent_training" />,
        },
        props: {
          style: {
            textAlign: "center",
            width: "9em",
          },
        },
        cell: {
          formatters: [
            (isTrue) =>
              isTrue && (
                <Text textAlign="center">
                  <PvCheck />
                </Text>
              ),
          ],
        },
        visible: true,
      },
      {
        property: "requiredForPersonTransport",
        header: {
          label: <Translate value="datatable.person_transport" />,
        },
        props: {
          style: {
            textAlign: "center",
            width: "12em",
          },
        },
        cell: {
          formatters: [
            (isTrue) =>
              isTrue && (
                <Text textAlign="center">
                  <PvCheck />
                </Text>
              ),
          ],
        },
        visible: true,
      },
    ];

    this.state = {
      // Default sorting
      sortingColumns: {
        lastName: {
          direction: "asc",
          position: 0,
        },
      },
      columns,
      rows: resolve({ columns })(this.props.rows || []),
    };
  }

  componentWillReceiveProps(props) {
    this.setState({ rows: props.rows });
  }

  render() {
    const { stylingRenderers, rowKey } = this.props;

    const { sortingColumns, columns, rows } = this.state;
    const visibleCols = columns.filter((column) => column.visible);
    const finalRows = compose(
      sort.sorter({
        columns: visibleCols,
        sortingColumns,
        sort: orderBy,
        strategy: sort.strategies.byProperty,
      })
    )(rows);

    return (
      <Table.Provider renderers={stylingRenderers} columns={visibleCols}>
        <Table.Header />
        <Table.Body rows={finalRows} rowKey={rowKey || "entityId"} />
      </Table.Provider>
    );
  }
}

LessonsEditDataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  highlightFn: PropTypes.func,
  stylingRenderers: PropTypes.object,
  filters: PropTypes.object,
  rowKey: PropTypes.string,
  tableType: PropTypes.string,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectLesson: (id) => selectLessonAction(id),
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(LessonsEditDataTable);



// WEBPACK FOOTER //
// ./src/components/datatable/LessonsEditDatatable.jsx